import React, { FC } from "react";
import { Button, Tooltip } from "antd";
import { TagsOutlined } from "@ant-design/icons";

import { useShowWbsCodes } from "./useWbsCodes";

interface WbsCodeToggleProps {
  /** Match the surrounding toolbar's control size. */
  size?: "small" | "middle" | "large";
}

/**
 * Toolbar button that shows/hides the WBS code and area prefix in phase and
 * activity names. Drop it into any screen's toolbar — all instances share one
 * preference, so the state is consistent wherever the user flips it.
 */
const WbsCodeToggle: FC<WbsCodeToggleProps> = ({ size }) => {
  const [showWbsCodes, setShowWbsCodes] = useShowWbsCodes();

  return (
    <Tooltip title={showWbsCodes ? "Hide WBS codes" : "Show WBS codes"}>
      <Button
        size={size}
        icon={<TagsOutlined />}
        type={showWbsCodes ? "primary" : "default"}
        aria-label={showWbsCodes ? "Hide WBS codes" : "Show WBS codes"}
        aria-pressed={showWbsCodes}
        onClick={() => setShowWbsCodes(!showWbsCodes)}
      />
    </Tooltip>
  );
};

export default WbsCodeToggle;
